export default __webpack_public_path__ + "static/media/500.cc24185d.png";